import { query, where, getDocs } from "firebase/firestore";
import {
  fetchAll,
  createDocWithId,
  updateDocById,
  deleteDocById,
  collRef,
} from "./firestoreHelpers";
import { calcularFactorIPC } from "../utils/ipcCalculations";

const COLL = "alquileres_indices";

// Each entry: { idFirebase, tipo (IPC/ICL/CASA_PROPIA), mes, anio, valor (percentage), acumulado }
const sortDesc = (arr) =>
  arr.sort((a, b) => (a.anio !== b.anio ? b.anio - a.anio : b.mes - a.mes));

export const getIndices = async () => sortDesc(await fetchAll(COLL));

export const getIndicesByTipo = async (tipo) => {
  const q = query(collRef(COLL), where("tipo", "==", tipo));
  const snap = await getDocs(q);
  return sortDesc(snap.docs.map((d) => ({ idFirebase: d.id, ...d.data() })));
};

// Upsert by (tipo, mes, anio)
export const saveIndice = async (data) => {
  const q = query(
    collRef(COLL),
    where("tipo", "==", data.tipo),
    where("mes", "==", data.mes),
    where("anio", "==", data.anio)
  );
  const snap = await getDocs(q);
  if (!snap.empty) {
    const id = snap.docs[0].id;
    await updateDocById(COLL, id, data);
    return id;
  }
  return createDocWithId(COLL, data);
};

export const deleteIndice = async (id) => deleteDocById(COLL, id);

// Adjustment factor for indices of `tipo` between (desdeAnio, desdeMes) and
// (hastaAnio, hastaMes). ICL uses the ratio between absolute values. IPC and
// CASA_PROPIA sum monthly percentages over [desde, hasta) -- desde month
// inclusive, hasta month exclusive (the months consumed during the cycle).
// Returns 1 if data is missing.
export const calcularIndiceAcumulado = async (tipo, desdeAnio, desdeMes, hastaAnio, hastaMes) => {
  const indices = await getIndicesByTipo(tipo);
  if (!indices.length) return 1;

  if (tipo === "ICL") {
    const desdeIdx = indices.find((i) => i.anio === desdeAnio && i.mes === desdeMes);
    const hastaIdx = indices.find((i) => i.anio === hastaAnio && i.mes === hastaMes);
    if (!desdeIdx || !hastaIdx) return 1;
    const desdeV = Number(desdeIdx.valor);
    const hastaV = Number(hastaIdx.valor);
    if (!desdeV || !hastaV) return 1;
    return hastaV / desdeV;
  }

  const fechaDesde = new Date(desdeAnio, desdeMes - 1, 1);
  const fechaHasta = new Date(hastaAnio, hastaMes - 1, 1);
  const res = calcularFactorIPC(indices, fechaDesde, fechaHasta);
  return res ? res.factor : 1;
};
